import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { callService } from "../service/service";
import LinearProgress from "@mui/material/LinearProgress";
import "../App.css";

export default function StudentInfo({ changeStep, course, value, name }) {
  const [lessons, setLessons] = useState([]);

  useEffect(() => {
    const checkWords = async () => {
      let date = new Date();
      console.log(value);
      let resp = await callService("LESSONS", {
        token: localStorage.getItem("token"),
        course: course.id,
        student: value,
      });
      console.log(resp);
      if (resp && resp.status) {
        setLessons(resp.lessons);
      } else {
        window.location.reload(false);
      }
    };
    checkWords();
  }, [course]);

  const goBack = () => {
    changeStep("students");
  };

  return (
    <div className="mainBox">
      <div className="backBox">
        <div style={{ paddingBottom: 10 }}>
          <b>{name}</b>
        </div>
        <Button
          variant="contained"
          onClick={goBack}
          style={{ backgroundColor: "gray" }}
        >
          Volver
        </Button>
      </div>

      <div className="subBox" style={{ marginTop: 90 }}>
        {lessons.length > 0 ? (
          lessons.map((o, index) => (
            <Button
              key={index}
              variant="contained"
              style={{ margin: 10, backgroundColor: "#C26400" }}
              onClick={() => {
                changeStep("wordInfo", o.id, value, name);
              }}
            >
              {o.name}
              {o.success > 0 && <br />}
              {o.success > 0 && o.success + "/" + o.total}
              <br />
              Intentos: {o.attempts ? o.attempts : 0}
            </Button>
          ))
        ) : (
          <div>
            <LinearProgress style={{ marginBottom: 20, marginTop: 20 }} />
          </div>
        )}
      </div>
    </div>
  );
}
